<template>
<div>
  <v-navigation-drawer v-model="sidenav" right temporary fixed>

    <v-list class="py-0">
      <v-list-tile avatar>
        <template v-if="user">
          <v-list-tile-avatar>
            <v-icon color="primary" large>face</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="title pt-1"><b>{{user.displayName}}</b></v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn @click.native="navigate('/sign-out')" class="mx-2 my-0" color="error" :disabled="appLoading" icon flat>
              <v-icon small>fas fa-sign-out-alt</v-icon>
            </v-btn>
          </v-list-tile-action>
        </template>
        <template v-else>
          <v-list-tile-content>
            <v-btn @click.native="navigate('/sign-in')" class="my-0 mx-auto" color="success" :disabled="appLoading" depressed>
              <span class="subheading"><b>Sign In</b></span>
            </v-btn>
          </v-list-tile-content>
        </template>
      </v-list-tile>
    </v-list>
    <v-divider class="mb-3"></v-divider>
    <v-list class="py-0">
      <template v-if="user && user.type.toLowerCase() == 'admin'">
        <v-subheader class="grey--text text--darken-2">User Navigation</v-subheader>
        <v-list-tile @click="" v-for="link in adminMenu" :key="link.title" :to="link.url" avatar>
          <v-list-tile-avatar>
            <v-icon class="mr-0">{{link.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>
            <b>{{link.title}}</b>
          </v-list-tile-title>
        </v-list-tile>
        <v-divider class="my-2"></v-divider>
      </template>
      <template v-else-if="user && user.type.toLowerCase() == 'student'">
        <v-subheader class="grey--text text--darken-2">User Navigation</v-subheader>
        <v-list-tile @click="" v-for="link in studentMenu" :key="link.title" :to="link.url" avatar>
          <v-list-tile-avatar>
            <v-icon class="mr-0">{{link.icon}}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>
            <b>{{link.title}}</b>
          </v-list-tile-title>
        </v-list-tile>
        <v-divider class="my-2"></v-divider>
      </template>
      <v-subheader class="grey--text text--darken-2">Main Navigation</v-subheader>
      <v-list-tile @click="sidenav = false" v-for="link in mainMenu" :key="link.title" :to="link.url" avatar>
        <v-list-tile-avatar>
          <v-icon>{{link.icon}}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>
          <b>{{link.title}}</b>
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>

  <v-toolbar style="background-color: rgba(179, 157, 219, 0.8);" class="elevation-5" dark fixed>
    <v-toolbar-title class="ml-3 -secondary--text">
      <span v-if="appLoading"><b>Rophem</b></span>
      <router-link v-else to="/" tag="span" style="cursor: pointer" exact>
        <b>Rophem</b>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn v-if="!appLoading && isStudent" to="/my-courses" class="my-0 mr-2" flat depressed>My Courses</v-btn>
    <v-btn v-if="!appLoading && !user && !inAuthFlow" @click="navigate('/sign-in')" class="my-0 mr-2" flat depressed>Sign In</v-btn>
    <template v-if="!appLoading && isAdmin">
      <v-badge :value="notifications.length > 0" color="accent" overlap>
        <span slot="badge">{{ notifications.length }}</span>
        <v-menu :close-on-content-click="false" v-model="notificationMenu" offset-y>
          <v-btn slot="activator" class="my-0" :disabled="appLoading" icon depressed>
            <v-icon>notification_important</v-icon>
          </v-btn>
          <v-card>
            <v-toolbar class="transparent" flat>
              <v-toolbar-title>Notifications</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="notificationMenu = false" class="my-0" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list>
              <v-list-tile @click="dismissNotification(notification)" class="mb-2" v-for="(notification, i) in notifications" :key="i">
                <v-list-tile-content>
                  <v-list-tile-title>{{ new Date(notification.createdOn).toLocaleString() }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ notification.message }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </v-badge>
    </template>
    <template v-if="!inAuthFlow">
      <v-badge :value="false" class="mx-1" color="accent" overlap>
        <span slot="badge">7</span>
        <v-btn @click.native="sidenav = !sidenav" class="my-0" :disabled="appLoading" flat>
          <span class="subheading">Menu</span>
          <v-icon class="ml-1">menu</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <template v-else>
      <v-btn
        v-if="route == '/sign-out' || route == '/sign-in'"
        @click.native="goBack()"
        class="mx-2 my-0"
        :disabled="appLoading"
        flat
      ><span class="subheading"><b>Back</b></span>
      </v-btn>
      <v-btn v-else-if="route == '/sign-up'" to="/sign-in" class="mx-2 my-0" :disabled="appLoading" flat>
        <span class="subheading"><b>Back</b></span>
      </v-btn>
    </template>
  </v-toolbar>
</div>
</template>

<script>
export default {
  computed: {
    appLoading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    isAdmin () {
      return this.user ? this.user.type.toLowerCase() === 'admin' : false
    },
    isStudent () {
      return this.user ? this.user.type.toLowerCase() === 'student' : false
    },
    route () {
      return this.$route.fullPath
    },
    notifications () {
      return this.$store.getters.notifications.reverse()
    },
    inAuthFlow () {
      return this.route === '/sign-in' || this.route === '/sign-up' || this.route === '/sign-out' || this.route === '/reset'
    }
  },
  data: () => ({
    sidenav: false,
    usernav: false,
    notificationMenu: false,
    mainMenu: [
      {title: 'Home', url: '/', icon: 'home'},
      {title: 'About', url: '/about', icon: 'info'},
      {title: 'Courses', url: 'https://www.rophemnursing.com/nclex-prep', icon: 'library_books'},
      {title: 'Register', url: '/register', icon: 'how_to_reg'},
      {title: 'Nursing CE', url: 'https://www.rophemnursing.com/ce', icon: 'launch'}
    ],
    adminMenu: [
      {title: 'Dashboard', url: '/dashboard', icon: 'view_compact'},
      {title: 'My Courses', url: '/my-courses', icon: 'library_books'},
      {title: 'Course Content', url: '/content', icon: 'class'},
      {title: 'Questions', url: '/questions', icon: 'notes'},
      {title: 'Manage Courses', url: '/manage-courses', icon: 'library_books'},
      {title: 'Progress', url: '/progress', icon: 'bar_chart'},
      {title: 'Payments', url: '/payments', icon: 'monetization_on'},
      {title: 'Users', url: '/users', icon: 'people'}
    ],
    studentMenu: [
      {title: 'My Courses', url: '/my-courses', icon: 'library_books'}
    ]
  }),
  methods: {
    navigate (path) {
      if (path === '/sign-out' || path === '/sign-in') this.$store.dispatch('setUserRoute', this.$route.fullPath)
      this.$router.push(path)
    },
    goBack () {
      if (this.$store.getters.userRoute === '') this.$router.push('/')
      else this.$router.push(this.$store.getters.userRoute)
    },
    dismissNotification (notification) {
      this.$store.dispatch('deleteNotification', notification).then(() => {
        const appMsg = {
          type: 'success',
          msg: 'Notification dismissed'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      }).catch(err => {
        console.log(err)
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/Navbar.vue